export default __webpack_public_path__ + "static/imgResearch-0e6c1d8618528725fa6a3f6b6802dd70.png";